var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 43,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M2.667 0C1.2 0 0 1.21 0 2.688v37.624C0 41.791 1.2 43 2.667 43h26.666C30.8 43 32 41.79 32 40.312V10L21.986 0H2.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A89A6",
    d: "M24.33 10H32L22 0v7.613c0 1.4.925 2.387 2.33 2.387Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 6,
    y: 18,
    fill: "#fff",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 6,
    y: 23,
    fill: "#fff",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 6,
    y: 28,
    fill: "#fff",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 6,
    y: 33,
    fill: "#fff",
    rx: 1
  })));
};
export default SvgFile;